<template>
  <kab-card>
    <template #card-image>
      <div class="boder-image-circle">
        <img
          alt="kab logo"
          class="image-avatar"
          :src="userImage"
        >
      </div>
    </template>
    <template #card-details>
      <div class="md-layout md-alignment-center-center user-name"> 
        <h1 v-html="title" />
      </div>
      <div class="md-layout md-alignment-center-center studio-name"> 
        <p v-html="studioName" />
      </div>
      <div>
        <div
          class="body-details"
          v-html="content"
        />
        <a
          v-if="body.length"
          @click="showDetails"
        >Read more</a>
      </div>
    </template>
  </kab-card>
</template>
<script>
import KabCard from '../KabCard'
export default {
  name: "ApprenticeLis",
  components: {
    KabCard
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    studioName: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  computed: {
    userImage () {
      return this.image.length ? this.image : require('@/assets/avatar.svg')
    },
    content () {
      return `${this.body.substring(0, 200)}${this.body.length ? `...` : ''}`
    }
  },
  methods: {
    showDetails() {
      this.$emit('selected', this.id)
    }
  }
}
</script>
<style lang="scss" scoped>
.user-name {
  h1 {
    margin-bottom: 0;
  }
}
.boder-image-circle {
  padding: 0px 10px 0px 10px;
}
.studio-name {
  font-size: 14px;
  line-height: 1.71;
  text-align: center;
  color: #a1aeb7;
  margin-bottom: -10px;
}
a {
  cursor: pointer;
}
</style>